export type AdminGrantScope = 'center' | 'network';

/**
 * Droits d'administration — collection distincte des affiliations
 * pédagogiques : règles d'écriture plus strictes (attribution réservée aux
 * admins habilités, aucune auto-attribution), ne pas mélanger les deux.
 */
export class AdminGrant {
  constructor(
    public identityId: string,
    public scope: AdminGrantScope,
    public grantedBy: string,
    public trainingCenterId?: string | null,
    public networkId?: string | null,
    public id?: string,
    public grantedAt?: string,
    public revokedAt?: string | null,
  ) {}

  static fromObject(data: any): AdminGrant {
    return new AdminGrant(
      data?.identityId,
      data?.scope,
      data?.grantedBy,
      data?.trainingCenterId ?? null,
      data?.networkId ?? null,
      data?.id,
      data?.grantedAt,
      data?.revokedAt ?? null,
    );
  }

  static toObject(grant: AdminGrant): any {
    const data: any = {
      identityId: grant.identityId,
      scope: grant.scope,
      grantedBy: grant.grantedBy,
      trainingCenterId: grant.trainingCenterId ?? null,
      networkId: grant.networkId ?? null,
    };

    if (grant.grantedAt !== undefined) {
      data.grantedAt = grant.grantedAt;
    }
    if (grant.revokedAt !== undefined) {
      data.revokedAt = grant.revokedAt;
    }

    return data;
  }
}
